import {
  Accordion,
  AccordionSizeEnum,
  AccordionVariantEnum,
  AssignIcon,
  Card,
  PaginatorTwoPagesIcon,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GeneralHeader } from '@/components/HeaderPage/HeaderPage';
import { ReportComponent } from '@/features/broadcast-schedule-program/components/ReportDrawer/components/ReportComponent';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';

import {
  ESegmentToolkit,
  TBroadcastScheduleProgramBodySegmentToolkitAdvertisementItem,
} from '../../types';

import { BroadcastScheduleProgramBodySegmentToolkitAditionalInfoDetails } from './components/BroadcastScheduleProgramBodySegmentToolkitAditionalInfoDetails';
import { BroadcastScheduleProgramBodySegmentToolkitAditionalInfoTable } from './components/BroadcastScheduleProgramBodySegmentToolkitAditionalInfoTable';
import { getSegmentAssignations } from './utils';

export default function BroadcastScheduleProgramBodySegmentToolkitAditionalInfo() {
  const { t } = useTranslation();
  const { handleTooltikClick, activeSegment } = useBroadcastScheduleProgram();
  const [accordionsOpen, setAccordionsOpen] = useState<Set<string>>(new Set(['detalle']));
  const segmentAsignations: TBroadcastScheduleProgramBodySegmentToolkitAdvertisementItem[] =
    activeSegment ? getSegmentAssignations(activeSegment) : [];

  const handleToggleAccordion = (accordion: string) => {
    setAccordionsOpen(prev => {
      const newSet = new Set(prev);
      if (newSet.has(accordion)) {
        newSet.delete(accordion);
      } else {
        newSet.add(accordion);
      }
      return newSet;
    });
  };

  return (
    <Card
      classes={{
        rootSection: clsx('w-full flex-auto order-3 lg:order-2'),
        container: 'py-size-4',
      }}
    >
      <div className="flex w-full flex-col gap-2">
        <>
          <GeneralHeader
            name={t('Información')}
            onClose={() => handleTooltikClick(ESegmentToolkit.INFORMACION)}
          />
          {activeSegment?.review_state === 5 && (
            <ReportComponent item={activeSegment} type="segment" />
          )}

          <Accordion
            variant={AccordionVariantEnum.Annotation}
            title={t('Detalle')}
            icon={PaginatorTwoPagesIcon}
            isOpen={accordionsOpen.has('detalle')}
            onOpen={() => {
              handleToggleAccordion('detalle');
            }}
            size={AccordionSizeEnum.Sm}
          >
            <BroadcastScheduleProgramBodySegmentToolkitAditionalInfoDetails item={activeSegment} />
          </Accordion>
          <Accordion
            variant={AccordionVariantEnum.Annotation}
            title={t('Asignación')}
            icon={AssignIcon}
            isOpen={accordionsOpen.has('asignacion')}
            onOpen={() => {
              handleToggleAccordion('asignacion');
            }}
            size={AccordionSizeEnum.Sm}
          >
            <BroadcastScheduleProgramBodySegmentToolkitAditionalInfoTable
              items={segmentAsignations}
            />
          </Accordion>
        </>
      </div>
    </Card>
  );
}
